import Role from './models/Role'
import { IAMAPI } from './API'
import {
  FindRolesQuery,
  CreateRolePayload,
  UpdateRolePayload,
  RoleDTO,
} from './dtos/role'
import { collection } from 'infra/collection'
import { GetCurrentWorkspace } from './SessionStore'
import { Id, PrimeProps } from 'types/definitions'

export type PrimeRole = (props: PrimeProps<RoleDTO, 'id'>) => Role | undefined

export default class RoleStore {
  roles = collection<RoleDTO, Role>({
    create: () => new Role(),
  })

  constructor(
    private api: IAMAPI,
    private getCurrentWorkspace: GetCurrentWorkspace
  ) {}

  forWorkspace(workspaceId: string) {
    return this.roles.filter((x) => Id.assert(x.workspaceId) === workspaceId)
  }

  async get(id: string) {
    return this.api.roles.get(id).then((data) => this.roles.set(data))
  }

  async find(query: FindRolesQuery) {
    return this.api.roles
      .find({
        ...query,
      })
      .then((data) => this.roles.set(data))
  }

  async create(data: CreateRolePayload) {
    return this.api.roles
      .create({
        ...data,
      })
      .then((data) => this.roles.set(data))
  }

  async update(id: string, data: UpdateRolePayload) {
    return this.api.roles.update(id, data).then((data) => this.roles.set(data))
  }

  async destroy(id: string) {
    return this.api.roles.delete(id).then(() => this.roles.remove(id))
  }
}
